<template>
  <div>
    <a-steps :current="current">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" />
    </a-steps>
    <div class="steps-content">
      <div v-if="current==0">
        <h3 style="margin-left:100px;">基本信息填写：</h3>
        <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
          <div class="m_flex_column" style="width:100px;">姓名：</div>
          <a-input v-model="name" placeholder="请输入" allowClear style="width:500px" />
        </div>
        <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
          <div class="m_flex_column" style="width:100px;">手机号：</div>
          <a-input v-model="phone" placeholder="请输入" allowClear style="width:500px" />
        </div>
        <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
          <div class="m_flex_column" style="width:100px;">身份证号</div>
          <a-input v-model="id_code" placeholder="请输入" allowClear style="width:500px" />
        </div>
        <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
          <div class="m_flex_column" style="width:100px;">性别</div>
          <a-select style="width: 120px" v-model="sex">
            <a-select-option value="0">男</a-select-option>
            <a-select-option value="1">女</a-select-option>
            <a-select-option value="-1">未知</a-select-option>
          </a-select>
        </div>

        <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
          <div class="m_flex_column" style="width:100px;">关联单位</div>
          <a-select style="width: 120px" v-model="unit_id">
            <a-select-option
              v-for="unit in unitList"
              :key="unit.key"
              :value="unit.key"
            >{{ unit.name }}</a-select-option>
          </a-select>
        </div>
      </div>
      <div v-if="current==1">
        <h3 style="margin-left:10px;">认证信息填写：</h3>

        <a-table :columns="columns" :dataSource="otherInfoDataList" bordered :pagination="false">
          <template slot="operation" slot-scope="text, record">
            <a @click="() => otherInfoEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除吗?" @confirm="() => otherInfoDelete(record)">
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
        </a-table>

        <div style="width:100%;text-align:center;margin-top:30px;">
          <a-button type="primary" @click="addOtherInfo">增加新的认证信息</a-button>
        </div>
      </div>
    </div>
    <div class="steps-action">
      <a-button v-if="current < steps.length - 1" type="primary" @click="next">基本信息完成</a-button>
      <a-button v-if="current > 0" style="margin-right: 15px" @click="prev">修改基本信息</a-button>
      <a-button v-if="current == steps.length - 1" type="primary" @click="handleSubmit">提交</a-button>
    </div>

    <a-modal v-model="addOtherInfoVisible" title="增加一条认证信息" @ok="addOk">
      <div class="m_flex_row" style="margin-left:0px;margin-top:10px;">
        <div class="m_flex_column" style="width:150px;">认证信息名称:</div>
        <a-input v-model="title" placeholder="请输入" allowClear style="width:500px" />
      </div>

      <div class="m_flex_row" style="margin-left:0px;margin-top:20px;">
        <div class="m_flex_column" style="width:150px;">认证信息介绍:</div>
        <a-textarea
          v-model="introduce"
          placeholder="请输入"
          allowClear
          style="width:500px"
          :autosize="{ minRows: 6, maxRows: 20 }"
        />
      </div>

      <div class="m_flex_row" style="margin-left:0px;margin-top:20px;">
        <div class="m_flex_column" style="width:150px;">附件:</div>
        <a-upload
          :data="file_data"
          style="width:500px"
          name="file"
          :multiple="true"
          :file-list="fileList"
          :action="uploadURL+1"
          :withCredentials="withCredentials"
          :headers="headers"
          @change="handleChange"
        >
          <a-button>
            <a-icon type="upload" />点击上传
          </a-button>
        </a-upload>
      </div>
    </a-modal>
  </div>
</template>

<script>
import request from "../../utils/request";
import Global from "../../global_variable";
const columns = [
  {
    title: "序号",
    dataIndex: "the_id",
    width: "5%"
  },
  {
    title: "认证信息名称",
    dataIndex: "title",
    width: "25%"
  },
  {
    title: "认证信息介绍",
    dataIndex: "introduce",
    width: "25%"
  },
  {
    title: "附件",
    dataIndex: "files_text",
    width: "20%"
  },
  {
    title: "操作",
    width: "25%",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];
export default {
  data() {
    return {
      unit_id: "",
      columns,
      current: 0,
      steps: [
        {
          title: "基本信息"
        },
        {
          title: "认证信息"
        }
      ],
      addOtherInfoVisible: false,
      title: "",
      introduce: "",
      fileList: [],
      file_data: {
        authority: 500
      },
      uploadURL: Global.uploadURL,
      old: {},
      phone: "19965772170",
      id_code: "342221199105048216",
      name: "测试Mark",
      sex: "-1",
      //设置上传的请求头部，IE10 以上有效
      headers: {
        authorization: "authorization-text"
      },
      //上传请求时是否携带 cookie
      withCredentials: true,
      otherInfoDataList: [],
      current_the_id: -1,
      unitList: []
    };
  },
  mounted() {
    this.getData();
    this.getUnitList();
  },
  methods: {
    getData() {
      let the_id = this.$route.query.the_id;
      if (the_id) {
        request({
          url: "/doctor/" + the_id,
          method: "get",
          params: {}
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.phone = data.data.phone;
            this.id_code = data.data.id_code;
            this.name = data.data.name;
            this.unit_id = data.data.unit_id;
            this.sex = data.data.sex + "";
            let i = 1;
            this.otherInfoDataList = data.data.items.map(item => {
              item["the_id"] = i;
              i++;
              item["files_text"] = item["annexs"].map(file => {
                return file.name + "  ";
              });
              return item;
            });
            console.log("看看annexs", this.otherInfoDataList);
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    getUnitList() {
      request({
        url: "/edc_unit/all",
        method: "get",
        params: {
          page: this.page,
          page_size: 10,
          key: this.key
        }
      }).then(response => {
        if (response.data.success) {
          this.unitList = response.data.data;
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    otherInfoEdit(record) {
      console.log("点击编辑了", record);
      this.title = record["title"];
      this.current_the_id = record["the_id"];
      this.introduce = record["introduce"];
      let i = 0;
      this.fileList = record["annexs"].map(item => {
        i += 1;
        return {
          uid: i,
          name: item.name,
          status: "done",
          url: item.url,
          response: item
        };
      });
      this.addOtherInfoVisible = true;
    },
    otherInfoDelete(record) {
      console.log("点击删除了", record);
      this.otherInfoDataList = this.otherInfoDataList.filter(item => {
        return item["the_id"] !== record["the_id"];
      });
    },
    next() {
      this.current++;
    },
    prev() {
      this.current--;
    },
    addOtherInfo() {
      this.addOtherInfoVisible = true;
      this.current_the_id = -1;
    },
    handleChange(info) {
      console.log("info", info);
      let fileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      // fileList = fileList.slice(-2);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;
      // if (info.file.status !== "uploading") {
      //   console.log(info.file, info.fileList);
      // }
      // if (info.file.status === "done") {
      //   this.$message.success(`${info.file.name} 文件上传成功`);
      //   console.log("完成", info.file.response);
      //   console.log("完成2",this.fileList);
      // } else if (info.file.status === "error") {
      //   this.$message.error(`${info.file.name} file upload failed.`);
      // }
    },
    addOk() {
      console.log("this.fileList", this.fileList);
      for (let i = 0; i < this.fileList.length; i++) {
        let file = this.fileList[i];
        if (file.status !== "done") {
          this.$message.error("请等待附件上传完成再点击确定");
          return;
        }
      }
      if (this.title.length < 1 && this.introduce.length < 1) {
        this.$message.error("请输入认证信息名称");
        return;
      }
      if (this.current_the_id !== -1) {
        this.otherInfoDataList = this.otherInfoDataList.map(item => {
          if (item.the_id === this.current_the_id) {
            item.title = this.title;
            item.introduce = this.introduce;
            item.annexs = this.fileList.map(item => {
              return item.response;
            });
          }
          return item;
        });
        this.addOtherInfoVisible = false;
        this.title = "";
        this.introduce = "";
        this.fileList = [];
      } else {
        this.otherInfoDataList.push({
          title: this.title,
          introduce: this.introduce,
          annexs: this.fileList.map(item => {
            return item.response;
          })
        });
        let i = 1;
        this.otherInfoDataList = this.otherInfoDataList.map(item => {
          item["the_id"] = i;
          item["files_text"] = item["annexs"].map(file => {
            return file.name + "  ";
          });
          i += 1;
          return item;
        });
        this.addOtherInfoVisible = false;
        this.title = "";
        this.introduce = "";
        this.fileList = [];
      }
    },
    handleSubmit() {
      let the_id = this.$route.query.the_id;
      if (the_id) {
        request({
          url: "/doctor/update",
          method: "POST",
          data: {
            docker_id: the_id,
            name: this.name,
            phone: this.phone,
            id_code: this.id_code,
            sex: this.sex,
            unit_id: this.unit_id,
            items: this.otherInfoDataList
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success(data.msg);
            this.$router.push({ path: "/doctor/all" });
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      } else {
        request({
          url: "/doctor/add",
          method: "POST",
          data: {
            name: this.name,
            phone: this.phone,
            id_code: this.id_code,
            sex: this.sex,
            unit_id: this.unit_id,
            items: this.otherInfoDataList
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success(data.msg);
            this.$router.push({ path: "/doctor/all" });
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      }
    }
  }
};
</script>


<style>
.steps-content {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  padding-top: 40px;
  padding-bottom: 80px;
}

.steps-action {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}
</style>
